let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iwo4w")).then(() => parcelRequire('2TWCz'));